import Endpoint from "@/utils/endPoint";

const studentListEndpoint = new Endpoint("/students/teachers/");
const studentEndpoint = new Endpoint("/students/teachers/{studentId}");
const teacherKinsfolkEndpoint = new Endpoint("/students/teachers/kinsfolk_info_from_teacher/{id}");
const addTeacherKinsfolkEndpoint = new Endpoint("/students/teachers/{studentId}/kinsfolk_info_from_teacher");
const acceptKinsfolkEndpoint = new Endpoint("/students/teachers/accept");
const declineKinsfolkEndpoint = new Endpoint("/students/teachers/decline");
const activateStudentEndpoint = new Endpoint("/students/teachers/{studentId}/activate");
const deactivateStudentEndpoint = new Endpoint("/students/teachers/{studentId}/deactivate");


const studentStatusEndpoint = new Endpoint("/students/teachers/{studentId}/status/{status}");
const statusLogListEndpoint = new Endpoint("/students/teachers/status_logs");
const statusLogEndpoint = new Endpoint("/students/teachers/status_logs/{id}");


class StudentService {
    async getStudentListService(params) {
        const result = await studentListEndpoint.get(params);
        return result;
    }
    async createStudentService(params) {
        const { klass_id, ...param } = params;
        const result = await studentListEndpoint.postWithParams([param], { klass_id });
        return result;
    }
    async getStudentService(params) {
        const result = await studentEndpoint.get(params);
        return result;
    }
    async updateStudentService(params) {
        const { studentId, ...param } = params;
        const result = await studentEndpoint.put(param, { studentId });
        return result;
    }
    async delStudentService(params) {
        const { studentId, ...param } = params;
        const result = await studentEndpoint.del(param, { studentId });
        return result;
    }
    
    async activateStudentService(params) {
        const { studentId, ...param } = params;
        const result = await activateStudentEndpoint.put(param, { studentId });
        return result;
    }

    async deactivateStudentService(params) {
        const { studentId, ...param } = params;
        const result = await deactivateStudentEndpoint.put(param, { studentId });
        return result;
    }

    async createKinsfolkService(params) {
        const { studentId, kinsfolkList } = params;
        const result = await addTeacherKinsfolkEndpoint.post(kinsfolkList, { studentId });
        return result;
    }

    async delKinsfolkService(params) {
        const result = await teacherKinsfolkEndpoint.del(null, params);
        return result;
    }

    async acceptKinsfolkService(params) {
        const result = await acceptKinsfolkEndpoint.postWithParams(null, params);
        return result;
    }

    async declineKinsfolkService(params) {
        const result = await declineKinsfolkEndpoint.postWithParams(null, params);
        return result;
    }

    

    async updateStudentStatusService(params) {
        const result = await studentStatusEndpoint.put(null, params);
        return result;
    }


    async getStatusLogListService(params) {
        const result = await statusLogListEndpoint.get(params);
        return result;
    }

    async createStatusLogService(params) {
        const result = await statusLogListEndpoint.post(params);
        return result;
    }

    async updateStatusLogService(params) {
        const { id, ...param } = params;
        const result = await statusLogEndpoint.put(param, { id });
        return result;
    }

    async delStatusLogService(params) {
        const { id, ...param } = params;
        const result = await statusLogEndpoint.del(param, { id });
        return result;
    }
}

export default new StudentService();
